import React from 'react'
import Layout from '../components/layout/Layout'
import NewsHome from '../components/news'

const NewsPage: React.FC = () => {
  return (
    <Layout
      title="News"
      description="Updates on Designing Multi-Agent Systems — new chapters, releases, talks and coverage."
    >
      <div className="mb-6"></div>
      <NewsHome isComponent={false} />
    </Layout>
  )
}

export default NewsPage